import React from "react";

import { Stack } from "@churchofjesuschrist/eden-stack";
import {
  spacing24 as indentation,
  yellow40 as downtimeColor,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import StyledHtmlFragment from "../../generic/styled-html-fragment/styled-html-fragment";
import { DateToDisplayString } from "../../utils/date-utils";
import useManagedStrings from "../../utils/use-managed-strings";

const OutageInnerStack = styled(Stack)`
  color: ${downtimeColor};
  margin-left: ${indentation};
`;

//Alerts usually show a translated string unless they are custom.
//This is going to be used in enough places that it makes sense to have it as a reusable component.
const stringGroups = [
  {
    name: "admin",
    keys: [
      "attendanceMessage",
      "yearTermMessage",
      "classCreationMessage",
      "classEditMessage",
      "studentProfileMessage",
      "graduationMessage",
      "reportsMessage",
      "studentMergeMessage",
      "schedulerMessage",
      "closeTermMessage",
      "downtimeMessage",
      "downtimeStartOn",
      "durationTime",
      "downtimeStartTime",
    ],
  },
];

const buildDurationTimeString = (alert, strings) => {
  let string = strings.durationTime;
  if (!string) {
    string = "";
  }
  if (string.indexOf("{duration}") < 0) {
    return "Invalid string for durationTime.  Missing {duration}";
  }
  return string.replace("{duration}", alert.duration);
};
const buildStartTimeString = (alert, strings) => {
  let string = strings.downtimeStartTime;
  if (!string) {
    string = "";
  }
  if (string.indexOf("{date}") < 0) {
    return "Invalid string for outage start.  Missing {date}";
  }
  if (string.indexOf("{time}") < 0) {
    return "Invalid string for outage start.  Missing {time}";
  }
  var returner = string.replace("{date}", DateToDisplayString(alert.startDate));
  returner = returner.replace("{time}", alert.startDescription);
  return returner;
};

const AlertMessageDisplay = ({ alert = {} }) => {
  const atype = alert?.type?.toLowerCase() ?? "";
  const {managedStrings:useStrings} = useManagedStrings(stringGroups);
  if (atype === "downtime") {
    return (
      <Stack gapSize="24">
        <span>{useStrings[`${atype}Message`]}</span>
        <Stack gapSize="8">
          <span>{useStrings.downtimeStartOn}</span>
          <OutageInnerStack gapSize="0">
            <span>{buildStartTimeString(alert, useStrings)}</span>
            <span>{buildDurationTimeString(alert, useStrings)}</span>
          </OutageInnerStack>
        </Stack>
      </Stack>
    );
  } else if (atype === "custom") {
    return <StyledHtmlFragment content={alert.message} />;
  } else {
    return <span>{useStrings[`${atype}Message`]}</span>;
  }
};

export default AlertMessageDisplay;
